import React, { useState, useEffect } from 'react'
import borderCheck from '../../../../assets/icons/border-check.svg'
import hourglass from '../../../../assets/icons/timeline.svg'
import { CloseOutlined } from '@ant-design/icons'

import styles from './index.module.scss'

function DemandsTimeline({ timeline, showExpandButton = true }) {
	const [isExpanded, setIsExpanded] = useState(false)
	const [timelineEvents, setTimelineEvents] = useState([])
	const [timelineEventsCount, setTimelineEventsCount] = useState(0)

	const actionDict = {
		approved: 'Aprovado',
		rejected: 'Rejeitado',
		skipped: 'Pulado',
		pending: 'Aguardando',
		archived: 'Arquivado',
	}

	const stepKeyMap = {
		abertura: 'área solicitante',
		gestora: 'área gestora',
		tecnica: 'área técnica',
		diretoria: 'diretoria',
		juridica: 'área jurídica',
		demandante: 'área solicitante',
		concluida: 'área solicitante',
	}

	function renderIcon(status) {
		switch (status) {
			case 'approved':
				return <img src={borderCheck} alt="approved-icon" />
			case 'pending':
				return (
					<img
						src={hourglass}
						alt="pending-icon"
						style={{ fill: '#8F09DB', stroke: '#8F09DB' }}
					/>
				)
			case 'rejected':
				return <CloseOutlined alt="rejected-icon" />
			case 'skipped':
				return <img src={borderCheck} alt="skipped-icon" />
			default:
				return <img src={borderCheck} alt="approved-icon" />
		}
	}

	useEffect(() => {
		const filterEvents = timeline.filter(
			(event) => event.status !== 'pending' && event.status !== 'skipped'
		)
		setTimelineEventsCount(filterEvents.length)
		if (isExpanded || !showExpandButton) {
			setTimelineEvents(filterEvents || [])
		} else {
			setTimelineEvents(filterEvents.slice(0, 2) || [])
		}
	}, [timeline, isExpanded])

	return (
		<section className={styles.section}>
			<h3 className={styles.sectionTitle}>Linha do tempo</h3>

			<div className={styles.timeline}>
				{timelineEvents.map((event, index) => (
					<div key={index} className={styles.timelineItem}>
						<div className={styles.timelineIconContent}>
							<div
								className={styles.timelineIcon}
								data-first={index === 0}
								data-last={index === timelineEvents.length - 1}>
								{renderIcon(event?.status)}
							</div>
						</div>
						<div className={styles.timelineItemContent}>
							<div className={styles.timelineContent}>
								<span className={styles.timelineAuthor}>
									{event?.actor_user?.name || ''}
								</span>
								<p className={styles.timelineAction}>
									<strong>{actionDict[event.status] || event.action}</strong>
									{!!stepKeyMap?.[event?.step_key] && ' pela '}
									<strong className={styles.timelineActionHighlight}>
										{stepKeyMap[event?.step_key] || ''}
									</strong>
								</p>
								<span className={styles.timelineDate}>
									{event?.created_at
										? new Intl.DateTimeFormat('pt-BR', {
												dateStyle: 'full',
												timeStyle: 'short',
												timeZone: 'America/Sao_Paulo',
											})
												.format(new Date(event.created_at))
												.replace(' às ', ' às ')
										: ''}
								</span>
								{event?.comments && (
									<blockquote className={styles.timelineQuote}>
										"{event?.comments}"
										<br />
										{event?.route_message ? (
											<i
												style={{ paddingTop: 4 }}>{`${event.route_message}`}</i>
										) : (
											''
										)}
									</blockquote>
								)}
							</div>
						</div>
					</div>
				))}
			</div>
			{timelineEventsCount > 2 && showExpandButton && (
				<button
					type="button"
					className={styles.historyButton}
					onClick={() => setIsExpanded(!isExpanded)}>
					{isExpanded ? 'Ver menos' : 'Ver histórico completo'}
				</button>
			)}
		</section>
	)
}

export default DemandsTimeline
